import {AxiosObjPlatformwithOutJWT as AxiosObj} from '../configuration/axios-setup';

class userAccountServices {
  getCurrentUserDetails(accountId) {    
    return AxiosObj
      .get(`/api/dpod/coach/${accountId}/account/me`)
  }
  getAccountSetting(accountId) {
    return AxiosObj
      .get(`/api/dpod/coach/${accountId}/account/settings`)
  }
  getStaffList(accountId, subscriptionId) {
    return AxiosObj
      .get(`/api/dpod/coach/${accountId}/staffs?subscription_id=${subscriptionId}`)
  }
  isConsumer(phoneNo) {    
    return AxiosObj
      .get(`/api/dpod/coach/is_consumer?phone_number=%2B${phoneNo}`)
  }
}

const UserAccount = new userAccountServices();
export default UserAccount;
